import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderJotdocsByJotdocId: build.query<
      GetV2ProviderJotdocsByJotdocIdApiResponse,
      GetV2ProviderJotdocsByJotdocIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotdocs/${queryArg.jotdocId}`,
      }),
    }),
    patchV2ProviderJotdocsByJotdocId: build.mutation<
      PatchV2ProviderJotdocsByJotdocIdApiResponse,
      PatchV2ProviderJotdocsByJotdocIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/jotdocs/${queryArg.jotdocId}`,
        method: "PATCH",
        body: queryArg.updateJotDocRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderJotdocsByJotdocIdApiResponse =
  /** status 200 OK */ JotDocResponse;
export type GetV2ProviderJotdocsByJotdocIdApiArg = {
  jotdocId: string;
};
export type PatchV2ProviderJotdocsByJotdocIdApiResponse =
  /** status 200 OK */ JotDocResponse;
export type PatchV2ProviderJotdocsByJotdocIdApiArg = {
  jotdocId: string;
  updateJotDocRequest: UpdateJotDocRequest;
};
export type JotDoc = {
  content?: string | null;
  created_at?: string | null;
  description?: string | null;
  encounter_id?: string | null;
  jotdoc_id: string;
  modified_at?: string | null;
  status?: "pending" | "completed";
  task_id?: string | null;
  thread_id?: string | null;
  title?: string | null;
  type: string;
};
export type JotDocResponse = {
  /** ID of the encounter associated with this JotDoc */
  encounter_id?: string | null;
  /** JotDoc document */
  jotdoc?: JotDoc | null;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type UpdateJotDocRequest = {
  /** Dictionary of fields to update */
  updated_fields: {
    [key: string]: any;
  };
};
